// extracted by mini-css-extract-plugin
export default {"smallMarginY":"pYz84dpzWaOaMJQdY0PL","mediumMarginY":"hokUgigXjv3Ct567NqHM","largeMarginY":"F_F2A__v2vFERKMy8jfo"};